import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7071 9.70711C12.3166 10.0976 11.6834 10.0976 11.2929 9.70711L7.29289 5.70711C6.90237 5.31658 6.90237 4.68342 7.29289 4.29289C7.68342 3.90237 8.31658 3.90237 8.70711 4.29289L12 7.58579L15.2929 4.29289C15.6834 3.90237 16.3166 3.90237 16.7071 4.29289C17.0976 4.68342 17.0976 5.31658 16.7071 5.70711L12.7071 9.70711Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.29289 19.7071C7.68342 20.0976 8.31658 20.0976 8.70711 19.7071L12 16.4142L15.2929 19.7071C15.6834 20.0976 16.3166 20.0976 16.7071 19.7071C17.0976 19.3166 17.0976 18.6834 16.7071 18.2929L12.7071 14.2929C12.3166 13.9024 11.6834 13.9024 11.2929 14.2929L7.29289 18.2929C6.90237 18.6834 6.90237 19.3166 7.29289 19.7071Z"
    />
  </svg>
);

const Selector2Icon = (props) => <Icon component={SVG} {...props} />;

export default Selector2Icon;
